import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared/shared.module";
import { SettingsModule } from "../common/settings/settings.module";
import { EmptyLayoutModule } from "./empty/empty.module";
import { CenteredLayoutModule } from "./horizontal/centered/centered.module";
import { EnterpriseLayoutModule } from "./horizontal/enterprise/enterprise.module";
import { MaterialLayoutModule } from "./horizontal/material/material.module";
import { ModernLayoutModule } from "./horizontal/modern/modern.module";
import { LayoutComponent } from "./layout.component";
import { ClassicLayoutModule } from "./vertical/classic/classic.module";
import { ClassicEnfinityLayoutModule } from "./vertical/classicenfinity/classicenfinity.module";
import { ClassicLightLayoutModule } from "./vertical/classiclight/classiclight.module";
import { ClassyLayoutModule } from "./vertical/classy/classy.module";
import { CompactLayoutModule } from "./vertical/compact/compact.module";
import { CompactLightLayoutModule } from "./vertical/compactlight/compactlight.module";
import { DenseLayoutModule } from "./vertical/dense/dense.module";
import { FuturisticLayoutModule } from "./vertical/futuristic/futuristic.module";
import { ThinLayoutModule } from "./vertical/thin/thin.module";
import { GlobalCustomerSearchModule } from "../common/global-customer-search/global-customer-search.module";


const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Horizontal navigation
    CenteredLayoutModule,
    EnterpriseLayoutModule,
    MaterialLayoutModule,
    ModernLayoutModule,

    // Vertical navigation
    ClassicLayoutModule,
    ClassicLightLayoutModule,
    ClassyLayoutModule,
    CompactLayoutModule,
    CompactLightLayoutModule,
    DenseLayoutModule,
    FuturisticLayoutModule,
    ThinLayoutModule,
    ClassicEnfinityLayoutModule, 
    GlobalCustomerSearchModule //Added new
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        SharedModule,
        SettingsModule,
        ...layoutModules
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
